import { observer } from "mobx-react-lite";
import * as React from "react";
import { classNames } from "src/common/classNames";
import { MdmUploader, MdmUploadStore } from "src/components/MdmUploader";
import { castToFiles } from "src/components/MdmUploader/castToFiles";
import { UploaderViewDefault } from "src/components/MdmUploader/UploaderViewDefault";
import { UploadInfo } from "src/components/MdmUploader/UploadInfo";
import { ZMdmFile } from "src/types/ZMdmFile";

import * as styles from "./ExtensionFileField.module.less";

type PropsExtensionFileField = {
  value?: ZMdmFile | null;
  onChange?: (value: ZMdmFile | null) => void;
};

export const ExtensionFileField: React.FC<PropsExtensionFileField> = observer(
  ({ value, onChange }) => {
    const onChangeRef = React.useRef(onChange);
    onChangeRef.current = onChange;
    const store = React.useMemo(
      () =>
        new MdmUploadStore({
          isImage: false,
          maxCount: 1,
          onChange: (list) => {
            onChangeRef.current?.(list[0] ?? null);
          },
        }),
      [],
    );

    React.useEffect(() => {
      store.setExtFiles(castToFiles(value) ?? []);
    }, [value]);

    const isEmpty = store.intFiles.length === 0;

    return (
      <div className={classNames([styles.root, [isEmpty, styles.rootEmpty]])}>
        <MdmUploader store={store}>
          <UploaderViewDefault store={store} />
          <div className={styles.hint}>
            <UploadInfo store={store} />
          </div>
        </MdmUploader>
      </div>
    );
  },
);
